
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function BecomeCreator() {
  const sectionsList = [
    ["what_are_the_possibilities"],
    ["how_to_create_creator_account"],
    ["what_does_it_mean_that_fansi_verifies_my_accounts"],
    ["i_have_not_received_verification_code", "mailto:info@fansi.pl"],
    ["how_long_does_the_verification_process_take"],
    ["my_social_media_account_has_been_verified_what_next"],
    ["my_account_verification_has_been_reject_why", "mailto:info@fansi.pl"],
    [
      "do_you_need_to_accept_the_terms_of_cooperation_to_sell_on_fansi",
      "#section-8",
      "#section-9",
      "#section-10",
    ],
    ["i_am_under_18_can_i_sell_products_myself"],
    ["i_have_business_how_can_i_be_billed_with_fansi"],
    ["i_do_not_have_business_can_i_sell_products_on_fansi"],
  ]

  const props = getHelpCenterArticleProps(
    "helpBecomeCreator",
    "become_creator",
    sectionsList
  )

  return (
    <div>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...props} />
    </div>
  )
}
BecomeCreator.Layout = Help
export default BecomeCreator


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/become-a-creator',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  